import React from 'react';
import { ShippingAddressIcon } from 'components/common/icons';
import { Col, EditableInfoComponent, Row, Typography } from 'components';

const { Text } = Typography;

export interface DeliveryInformationData {
  deliveryAddress: string;
  deliveryTerms: string;
  insurance: string;
  deliveryCost: string;
  deliveryMargin: string;
  additionalServices: string;
}

export const DeliveryInformation = React.memo<{ data: DeliveryInformationData }>(({ data }) => {
  const { deliveryAddress, deliveryTerms, insurance, deliveryCost, deliveryMargin, additionalServices } = data;

  return (
    <Row>
      <Col span={24}>
        <EditableInfoComponent
          creatable={false}
          editable={false}
          icon={<ShippingAddressIcon />}
          title={'Delivery Information'}
        />
      </Col>

      <Col span={24}>
        {[
          ['Delivery Address', deliveryAddress],
          ['Delivery Terms', deliveryTerms],
          ['Insurance', insurance ? `${insurance}€` : null],
          ['Delivery Cost', deliveryCost ? `${deliveryCost}€` : null],
          ['Delivery Margin', deliveryMargin ? `${deliveryMargin}%` : null],
          ['Additional Services', additionalServices ? `${additionalServices}€` : null],
        ].map(([label, value]) => (
          <Row justify="space-between" key={label} wrap={false} gutter={10}>
            <Col>
              <Text type={'secondary'} className={'font-size-16'} style={{ whiteSpace: 'nowrap' }}>
                {label}
              </Text>
            </Col>
            <Col flex="0 1 auto">
              <Text
                type={'secondary'}
                className={'font-size-16'}
                style={{ whiteSpace: 'nowrap' }}
                ellipsis={{ tooltip: true }}
              >
                {value || 'Not Set'}
              </Text>
            </Col>
          </Row>
        ))}
      </Col>
    </Row>
  );
});
